import { useNavigate } from "react-router-dom";

import { IconButton, TooltipHost } from "@bps/fluent-ui";

interface DeviceSearchOnNameAndValueProps {
  name: string;
  value: string;
}

export const DeviceSearchOnNameAndValue = ({
  name,
  value
}: DeviceSearchOnNameAndValueProps) => {
  const navigate = useNavigate();

  const rules = [
    {
      attributeType: name,
      valueDataType: "STRING",
      comparisonOperator: "=",
      value
    }
  ];

  const tooltipString = `Search for all devices with matching property/identifier ${name} = ${value}`;

  const encoded = btoa(JSON.stringify(rules));

  return (
    <TooltipHost content={tooltipString}>
      <IconButton
        onClick={() => {
          navigate(`/system/plt/device-search?query=${encoded}`);
        }}
        iconProps={{
          iconName: "Search"
        }}
      />
    </TooltipHost>
  );
};
